export const PAYONEER_GET_EMPLOYEE_STATUS = "PAYONEER_GET_EMPLOYEE_STATUS";
export const PAYONEER_SET_EMPLOYEE_STATUS = "PAYONEER_SET_EMPLOYEE_STATUS";
export const PAYONEER_GET_EMPLOYEE_STATUS_FAILED = "PAYONEER_GET_EMPLOYEE_STATUS_FAILED";
